// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"87681ec0","320":"f82259f5","406":"853603c6","534":"2f607419","685":"f129a6f8","725":"7613ca03","749":"4d2f720b","768":"f4129ab2","903":"0fe7e298","959":"20cb500b"}[chunkId] + ".chunk.js";
};